import React from "react";
import KeyboardBackspaceRoundedIcon from "@material-ui/icons/KeyboardBackspaceRounded";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  backButton: {},
  backButtonLabel: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    "&:hover": {
      color: `${theme.palette.selected.main} !important`,
    },
  },
  firstCap: {
    textTransform: "lowercase !important",
    "&:first-letter": {
      textTransform: "capitalize !important",
    },
  },
}));

const BackButtonComponent = ({ url, handler }) => {
  const classes = useStyles();
  const intl = useIntl();
  const navigate = useNavigate();

  const handleGoBack = () => {
    !!handler && handler();
    navigate(!!url ? url : -1);
  };

  return (
    <Button className={classes.backButton} onClick={handleGoBack}>
      <div className={classes.backButtonLabel}>
        <KeyboardBackspaceRoundedIcon fontSize={"small"} />
        <Typography className={classes.firstCap}>{intl.formatMessage({ id: "back" })}</Typography>
      </div>
    </Button>
  );
};

export default BackButtonComponent;
